<template>
  <div class="content">
    <div class="header">
      <router-link to="/" class="header-logo">
        <img src="@/assets/images/logo-mini.svg" alt="" />
      </router-link>
      <h2 class="header-title">Demo Ads</h2>
      <div class="header-lang">
        <SelectLanguage />
      </div>
    </div>

    <div class="body">
      <NavBar :currentNav="currentNav" @setNav="setCurrentNav" />

      <component :is="currentNav" @setPosition="setPosition"></component>
    </div>

    <Transition name="slide">
      <component :is="currentWidget" :class="`widget ${position}`" @close="currentWidget = null" adTitle="Title" adText="Description"></component>
    </Transition>
  </div>
</template>

<script>
import SelectLanguage from "@/components/SelectLanguage";
import NavBar from "@/components/demo/NavBar";
import NativeWebPush from "@/components/demo/NativeWebPush.vue";
import OnClick from "@/components/demo/OnClick.vue";
import InPage from "@/components/demo/InPage.vue";
import Push from "@/components/InpageTemplates/NativeWebPush.vue";
import Main from "@/components/InpageTemplates/Main.vue";
import Telegram from "@/components/InpageTemplates/Telegram.vue";
import Android from "@/components/InpageTemplates/Android.vue";
import PureWhite from "@/components/InpageTemplates/Pure-white.vue";
import PurpleGradient from "@/components/InpageTemplates/Purple-gradient.vue";

export default {
  name: "PanelHeader",
  components: { SelectLanguage, NavBar, NativeWebPush, OnClick, InPage, Push, Telegram, Android, PureWhite, PurpleGradient, Main },
  data() {
    return {
      position: "top-left",
      currentNav: "OnClick",
      currentWidget: null,
      inPageWidgets: ["Main", "Telegram", "Android", "PureWhite", "PurpleGradient"],
      timerId: null,
      counter: 1,
    };
  },
  methods: {
    setCurrentNav(nav) {
      if (nav) {
        this.currentNav = nav;

        switch (nav) {
          case "NativeWebPush":
            this.position = "top-left";
            this.currentWidget = "Push";
            break;
          case "InPage":
            this.position = "bottom-right";
            this.currentWidget = "Main";
            break;
          default:
            this.currentWidget = null;
        }
      }
    },
    setPosition(value) {
      this.position = value;
      this.currentWidget = this.inPageWidgets[this.counter];
    },
  },
  watch: {
    currentNav() {
      clearInterval(this.timerId);

      if (this.currentNav === "InPage") {
        this.timerId = setInterval(() => {
          this.currentWidget = this.inPageWidgets[this.counter];

          this.counter >= 4 ? (this.counter = 0) : (this.counter += 1);
        }, 3000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/inpage-templates.css";
.content {
  max-width: 600px;
  margin-bottom: 80px;
}

.header {
  display: flex;
  align-items: center;
  margin: 20px 0;

  .header-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0 50px;
  }
}

@media screen and (max-width: 1200px) {
  .header {
    position: relative;
    z-index: 0;
    box-shadow: none;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-150%);
}
.slide-leave,
.slide-enter-to {
  transform: translateY(0%);
}

.slide-enter.bottom-left,
.slide-enter.bottom-right,
.slide-leave-to.bottom-left,
.slide-leave-to.bottom-right {
  transform: translateY(150%);
}
.slide-leave.bottom-left,
.slide-leave.bottom-right,
.slide-enter-to.bottom-left,
.slide-enter-to.bottom-right {
  transform: translateY(0%);
}

.widget {
  position: fixed;
  min-width: 310px;
  z-index: 999;

  &.top-left {
    top: 20px;
    left: 20px;
  }
  &.top-right {
    top: 20px;
    right: 20px;
  }
  &.bottom-left {
    bottom: 20px;
    left: 20px;
  }
  &.bottom-right {
    bottom: 20px;
    right: 20px;
  }
}
</style>
